export default __webpack_public_path__ + "static/media/team-bg.b9a32fe6.jpg";